import { GetDeliveryNumberApiParameter, getDeliveryNumbers } from "@dana/Services/DanaOrderRelatedService";
import { DanaDeliveryNumbersActions } from "@dana/Store/Data/OrderHistory/Reducers/GetDanaDeliveryNumbersReducer";
import { GetDeliveryNumbersResponseModel } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type GetDeliveryNumberOrderNumberRequestParameter = {
    orderNumber?: string;        
}& HasOnSuccess<any> & HasOnError;


type HandlerType =ApiHandlerDiscreteParameter<GetDeliveryNumberOrderNumberRequestParameter,GetDeliveryNumberApiParameter,GetDeliveryNumbersResponseModel, DispatchProp<DanaDeliveryNumbersActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "OrdersDelivery/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getDeliveryNumbers({
        orderNumber:props.parameter.orderNumber,        
    });   
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "OrdersDelivery/PopulateResult",              
            data: props.apiResult,
        } as any);
    }
}

export const chain = [SetLoadingOn,SendDataToApi, PopulateFacetResult];

const GetDeliveryNumbersHandler = createHandlerChainRunner(chain, "GetDeliveryNumbersHandler");
export default GetDeliveryNumbersHandler;